export default {
  primary: "Futura",
  primaryText: "Futura",
  secondary: "Caveat",
};
